export const loadingStateDataPlaceholder = (() => {
  const rows = {
    segment_name: '-',
    segment_size: '-',
    aclv: '-',
    ano: '-',
    aov: '-',
    gross_margin: '',
    acr: '',
    filters: '""',
  };
  return [...Array(20)].map(() => rows);
})();
